import React, { useEffect, useState } from 'react';
import { makeApiRequests } from '../helpers/api';
import { ENDPOINTS } from '../helpers/constants';
import './DevEnvIndicator.css';

const DevEnvIndicator = () => {
  const [serverInfo, setServerInfo] = useState(null);

  useEffect(() => {
    if (window.location.hostname !== 'localhost') return;
    makeApiRequests({ endpoint: ENDPOINTS.SERVER_INFO, method: 'GET' }).then(({ response }) => {
      if (response) setServerInfo(response);
    });
  }, []);

  if (!serverInfo) return null;

  const { dbEnvironment, isDevServer } = serverInfo;

  return (
    <div className="dev-env-indicator">
      <span className={`dev-env-indicator__dot dev-env-indicator__dot--${dbEnvironment}`} />
      <span className={`dev-env-indicator__env dev-env-indicator__env--${dbEnvironment}`}>
        {dbEnvironment} db
      </span>
      <span className="dev-env-indicator__divider" />
      <span className={`dev-env-indicator__dev-flag${!isDevServer ? ' dev-env-indicator__dev-flag--warning' : ''}`}>
        {!isDevServer && <i className="dev-env-indicator__warning-icon">⚠</i>}
        {isDevServer ? 'dev server' : 'NOT dev server'}
      </span>
    </div>
  );
};

export default DevEnvIndicator;
